import { channelsConstants } from '@constants/channels';
import { channelsService } from '@services';

function request() {
    return { type: channelsConstants.CHANNELS_FETCH };
}

function success(data) {
    return { type: channelsConstants.CHANNELS_SUCCESS, data };
}

function failure(message) {
    return { type: channelsConstants.CHANNELS_ERROR, message };
}

const get = () => {
    return dispatch => {
        dispatch(request());
        channelsService.get().then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
};

function update(data) {
    return { type: channelsConstants.CHANNELS_UPDATE, data };
}

function fetchWhatsAppBusinessPhoneNumbers() {
    return { type: channelsConstants.WHATSAPP_BUSINESS_PHONE_NUMBERS_FETCH };
}

function successWhatsAppBusinessPhoneNumbers(payload) {
    return { type: channelsConstants.WHATSAPP_BUSINESS_PHONE_NUMBERS_SUCCESS, payload };
}

function failureWhatsAppBusinessPhoneNumbers() {
    return { type: channelsConstants.WHATSAPP_BUSINESS_PHONE_NUMBERS_ERROR };
}

const getWhatsAppBusinessPhoneNumbers = () => {
    return dispatch => {
        dispatch(fetchWhatsAppBusinessPhoneNumbers());
        channelsService.getWhatsAppBusinessPhoneNumbers().then(
            data => dispatch(successWhatsAppBusinessPhoneNumbers(data)),
            () => dispatch(failureWhatsAppBusinessPhoneNumbers()),
        );
    };
};

function successWhatsAppBusinessTemplates(payload) {
    return { type: channelsConstants.WHATSAPP_BUSINESS_TEMPLATES_SUCCESS, payload };
}

function failureWhatsAppBusinessTemplates() {
    return { type: channelsConstants.WHATSAPP_BUSINESS_TEMPLATES_ERROR };
}

const getWhatsAppBusinessTemplates = () => {
    return dispatch => {
        channelsService.getWhatsAppBusinessTemplates().then(
            data => dispatch(successWhatsAppBusinessTemplates(data)),
            () => dispatch(failureWhatsAppBusinessTemplates()),
        );
    };
};

export const channelsActions = {
    get,
    update,
    getWhatsAppBusinessPhoneNumbers,
    getWhatsAppBusinessTemplates,
};
